import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { Company } from 'src/app/models/company';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PatientService } from '../../patient/service/patient.service';
import { ToastrService } from 'ngx-toastr';
import { messagelanguage } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { CreatelocalcompanyComponent } from '../createlocalcompany/createlocalcompany.component';

@Component({
  selector: 'app-admingeneralcompanyconfig',
  templateUrl: './admingeneralcompanyconfig.component.html',
  styleUrls: ['./admingeneralcompanyconfig.component.scss']
})
export class AdmingeneralcompanyconfigComponent implements OnInit {
  @Input() vc_idCompanyUser: number;
  @Output() obj_ConfirmLoad = new EventEmitter<boolean>(false);
  // obj_Company: Company = new Company(0,0,"","","","","","","","",0);
  obj_Company = new Company();          

  oc_localsCompany:any[];
  vc_hoverElement:any;
  vc_resetPasswordForm: FormGroup;
  vc_passwordResetSuccess: boolean;
  vc_showButtonClose:boolean = false;

  constructor(private oc_adminService: AdminService, 
    private oc_patientService: PatientService,
    public oc_dialog: MatDialog,
    public oc_toastr: ToastrService) { }

  ngOnInit() {
    this.fn_cargarDatos();
  }

  async fn_cargarDatos() {
    (await this.oc_adminService.getInfoDetailCompany(this.vc_idCompanyUser))
    .subscribe((res:any) => {
      this.obj_ConfirmLoad.emit(false); 
      this.obj_Company.businessName = res.body.infoCompany.nameCompany;
      this.obj_Company.ruc = res.body.infoCompany.ruc;
      this.obj_Company.eMail = res.body.infoCompany.eMail;
      this.obj_Company.iPress = res.body.infoCompany.iPress;
      this.obj_Company.ugiPress = res.body.infoCompany.ugiPress;
      this.obj_Company.phone = res.body.infoCompany.phone;
      this.obj_Company.address = res.body.infoCompany.address;
      this.obj_Company.idCompany = this.vc_idCompanyUser;
      
      this.oc_localsCompany = res.body.localsCompany;
      this.oc_localsCompany.push({idLocal:-1,nameLocal:"+ Agregar"})
      console.log(this.oc_localsCompany);

    },(error) => {
      console.error(error);
    })
  }

  async fn_save() {
    (await this.oc_adminService.createCompany(this.obj_Company)).subscribe(
      (res) => {
        this.oc_toastr.success(messagelanguage.message.Company_Updated);
      },(error) => {
        this.oc_toastr.error(messagelanguage.message.No_control_error + " : " + error.error.message);
      });
  }

  async fn_resetPassword() {
    const self = this;
    let currentPassword = self.vc_resetPasswordForm.get('iCurrentPassword').value;
    let newPassword = self.vc_resetPasswordForm.get('iPassword').value;

    (await this.oc_patientService
      .changePassword(currentPassword, newPassword))
      .subscribe((response: any) => {
        this.vc_passwordResetSuccess = true;
        this.oc_toastr.success(messagelanguage.message.Password_change_success);
      }, (error: any) => {
        if (error.status == 400 && error.error.message == "Password_update_wrong" ) {
          this.oc_toastr.error(messagelanguage.message.Password_update_wrong);
        } else if (error.status == 400 && error.error.message == "User_Not_Found" ) {
          this.oc_toastr.error(messagelanguage.message.User_Not_Found);
        } else if (error.status == 500 ) {
          this.oc_toastr.error(messagelanguage.message.No_control_error);
        }
      });
  }

  async fn_AddLocal(item:any) {
    let dialogRef = this.oc_dialog.open(CreatelocalcompanyComponent, {
      panelClass: 'custom-modal',
      data: {
        idCompany: this.vc_idCompanyUser,
        idLocal: item.idLocal,
      },
      autoFocus: false,
      maxWidth: '120vh',
    });
    dialogRef.afterClosed().subscribe((response: any) => { 
        if (!response) {
          this.oc_toastr.info(messagelanguage.message.Cancel_Process);
        } else {
          this.fn_cargarDatos();
        }
    });
  }

  // async fn_AddLocal(item:any) {
  //   let resourcesPath: string = 'users/resources';

  //   const countryId = (item && item.countryId) ? item.countryId.toString() : null;
    
  //     try {
  //       (await this.oc_patientService.getResources(resourcesPath, countryId))
  //         .subscribe((resources: any[]) => {
  //           let dialogRef = this.oc_dialog.open(CreatelocalcompanyComponent, {
  //             panelClass: 'custom-dialog',
  //             data: {
  //               idCompany: this.vc_idCompanyUser,
  //               idLocal: item.idLocal,
  //               resources_o: resources
  //             },
  //             autoFocus: false,
  //             maxWidth: '120vh',
  //           });
  //           dialogRef.afterClosed().subscribe((response: any) => { 
  //               if (!response) {
  //                 this.oc_toastr.info(messagelanguage.message.Cancel_Process);
  //               } else {
  //                 this.fn_cargarDatos();
  //               }
  //           });
  //         });
  //     } catch (error) {
  //       console.error(error);
  //       if (error.status === 500) {
  //         this.oc_toastr.error(
  //           messagelanguage.message.No_control_error + ' : ' + error.error.message
  //         );
  //       }
  //     }

    

  //   // (await this.oc_patientService
  //   //   .getResources(resourcesPath, countryId))
  //   //   .subscribe((response: any) => { 
  //   //     this.oc_patientService.resources.next(response.body);
  //   //       let dialogRef = this.oc_dialog.open(CreatelocalcompanyComponent, {
  //   //         panelClass: 'custom-dialog',
  //   //         data: {
  //   //           idCompany: this.vc_idCompanyUser,
  //   //           idLocal: item.idLocal,
  //   //           resources_o: response.body
  //   //         },
  //   //         autoFocus: false,
  //   //         maxWidth: '120vh',
  //   //       });
  //   //       dialogRef.afterClosed().subscribe((response: any) => { 
  //   //           if (!response) {
  //   //             this.oc_toastr.info(messagelanguage.message.Cancel_Process);
  //   //           } else {
  //   //             this.fn_cargarDatos();
  //   //           }
  //   //       });
  //   //   }, (error) => {
  //   //     if (error.status == 500) {
  //   //       this.oc_toastr.error(messagelanguage.message.No_control_error + " : " + error.error.message);
  //   //     }
  //   //     console.log(error);
  //   //   });

  // }

  async fn_deleteLocal(idLocal:number, name:string) {
    if(confirm('¿Desea borrar el Local ' + name + '?')) {
      (await this.oc_adminService.deletelocal(this.vc_idCompanyUser, idLocal)).subscribe(
        (res) => {
          this.oc_toastr.success(messagelanguage.message.LocalDeleted);
          this.fn_cargarDatos();
        },(error) => {
          if (error.status == 400 && error.error.message == "Not_Exist_Local" ) {
            this.oc_toastr.error(messagelanguage.message.Not_Exist_Local);
          } else if (error.status == 500 ) {
            this.oc_toastr.error(messagelanguage.message.No_control_error);
          }
        });
    }
  }
  

}
